import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'services/settings/SettingsContext';
import { convertUTCToLocalDateTimeString } from 'internationalization/timezoneConversions';
import { IntegrationPageContentProps } from '../IntegrationPage';

const ExactIntegrationPageContent: React.FC<IntegrationPageContentProps> = ({ 
    response,
    handleRefetch
}) => {
    const { t } = useTranslation();
    const { userLocale, userTimezone } = useSettings();

    // Poll for initial import progress when integration is active and initial import is running
    useEffect(() => {
        if (response && response.status === "active" && response.initial_import_running) {
            const interval = setInterval(() => {
                handleRefetch();
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [response?.initial_import_running, response?.status, handleRefetch]);

    return ( 
        <>
            {/* {response?.is_active && (
                <div className="integration-details">
                    <div className='header'>
                        {t(`integrations.general.info_title`)}:
                    </div>
                    <p>
                        {t(`integrations.general.${response.integration_name}.info_description`)}:
                    </p>

                    {response.export_hours && (
                        <p>
                            {t(`integrations.general.${response.integration_name}.export_hours_description`)}:
                        </p>
                    )}
                </div>
            )} */}

            {response?.initial_import_running && (
                <div className="integration-details">

                    <div className='header'>
                        {t(`integrations.general.initial_import_label`)}:
                    </div>

                    {response.import_sync_state?.map((entity: any) => {

                        if (entity.status === "completed") {
                            return (
                                <p key={entity.entity}>
                                    ✓ {t(`integrations.general.${response.integration_name}.${entity.entity}`)} {t(`integrations.general.imported_label`)}: ({entity.items_imported})
                                </p>
                            );
                        }

                        if (entity.status === "running") {
                            return (
                                <p key={entity.entity}>
                                    → {t(`integrations.general.${response.integration_name}.${entity.entity}`)} {t(`integrations.general.importing_label`)} ({entity.items_imported})
                                </p>
                            );
                        }

                        return (
                            <p key={entity.entity}>
                                {t(`integrations.general.${response.integration_name}.${entity.entity}`)} {t(`integrations.general.pending_label`)}
                            </p>
                        );
                    })}
                </div>
            )}

            {!response?.initial_import_running && response?.last_import_at && (
                <div className="integration-details">
                    <div className='header'>
                        {t(`integrations.general.last_import`)}: {new Date(convertUTCToLocalDateTimeString(response.last_import_at, userLocale, userTimezone)).toLocaleString()}
                    </div>
                    <div>
                        {response.import_sync_state?.map((entity: any) => (
                            <p key={entity.entity}>
                                {t(`integrations.general.${response.integration_name}.${entity.entity}`)}: {entity.last_run_items_imported} {t(`integrations.general.imported_label`)}
                            </p>
                        ))}
                    </div>
                </div>
            )}

            {response?.last_export_at && (
                <div className="integration-details">
                    <div className='header'>
                        {t(`integrations.general.last_export`)}: {new Date(convertUTCToLocalDateTimeString(response.last_export_at, userLocale, userTimezone)).toLocaleString()}
                    </div>
                    <div>
                        {response.export_sync_state?.map((entity: any) => (
                            <p key={entity.entity}>
                                {t(`integrations.general.${response.integration_name}.${entity.entity}`)}
                            </p>
                        ))}
                    </div>
                </div>
            )}

            {response?.last_rate_limit_daily_remaining != null && (
                <div className="integration-details">
                    <div className='header'>
                        {t(`integrations.general.remaining_daily_api_calls`)}: {response.last_rate_limit_daily_remaining}
                    </div>
                </div>
            )}
        </>
    );
};

export default ExactIntegrationPageContent;